import styled from "styled-components";

const LoaderContainer = styled.div<any>`
   display: flex;
   align-items: center;
   height: 100%;
   justify-content: center;
   position: absolute;
   top: 0;
   left: ${props => props.left ? "90%" :"50%"};
   transform: translateX(-50%);

   z-index: 2000;
`;
export default LoaderContainer;
